import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=7fe4c5ae&scoped=true"
import script from "./DisplayField.vue?vue&type=script&lang=ts"
export * from "./DisplayField.vue?vue&type=script&lang=ts"
import style0 from "./DisplayField.vue?vue&type=style&index=0&id=7fe4c5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_pqvrgeoyoc7vllsfv3djl2e3nu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4c5ae",
  null
  
)

export default component.exports